import { ChevronUpIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";

const ChatLauncher = ({ onClick, isOpen, unread }: any) => {
  const [backgroundColor, setBackgroundColor] = useState<any>(null);

  useEffect(() => {
    let timer: any = null;
    const updateBackgroundColor = () => {
      if (window && window.localStorage) {
        const config: any = window.localStorage.getItem("max_widget_config");
        const data = JSON.parse(config) || {};
        if (data.primaryColor?.length > 0) {
          setBackgroundColor(data.primaryColor);
          clearTimeout(timer);
        }
      }
    };

    updateBackgroundColor();
    window.addEventListener("storage", updateBackgroundColor);

    timer = setTimeout(updateBackgroundColor, 1000);

    return () => {
      window.removeEventListener("storage", updateBackgroundColor);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={"relative"}>
      <div
        onClick={onClick}
        className="relative w-12 h-12 text-gray-50 rounded-full flex items-center justify-center cursor-pointer text-3xl z-50"
        style={{ backgroundColor: backgroundColor }}
      >
        <ChevronUpIcon
          className={`size-6 absolute transition-transform duration-300 ${
            isOpen
              ? "rotate-0 scale-100 opacity-100"
              : "-rotate-180 scale-0 opacity-0"
          }`}
        />

        <div
          className={`absolute transition-all duration-300 ${
            isOpen ? "scale-0 opacity-0" : "scale-100 opacity-100"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className="h-6 w-6 text-white mt-[2px]"
            x="0"
            y="0"
            viewBox="0 0 24 24"
          >
            <g>
              <g>
                <path
                  fill="#ffffff"
                  d="M18 2H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4v3a1 1 0 0 0 1.71.71l3.7-3.71H18a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4z"
                  opacity="1"
                ></path>
                <g fill="#edebea">
                  <circle
                    cx="7.5"
                    cy="10"
                    r="1.5"
                    fill="#edebea"
                    opacity="1"
                  ></circle>
                  <circle
                    cx="12"
                    cy="10"
                    r="1.5"
                    fill="#edebea"
                    opacity="1"
                  ></circle>
                  <circle
                    cx="16.5"
                    cy="10"
                    r="1.5"
                    fill="#edebea"
                    opacity="1"
                  ></circle>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ChatLauncher;
